import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { fuseAnimations } from '@fuse/animations';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { ContainerOccupancyEmptyFullRate } from 'app/models/container-occupancy-empty-full-rate.model';
import { ContainerOccupancyReport } from 'app/models/container-occupancy-report.model';
import { Container } from 'app/models/container.model';
import { ContainerService } from 'app/services/container.service';
import { ExcelService } from 'app/services/excel.service';
import { ReportingService } from 'app/services/reporting.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApexChart, ApexDataLabels, ApexNonAxisChartSeries, ApexResponsive, ChartComponent } from 'ng-apexcharts';
export type ChartOptions = {
    series: ApexNonAxisChartSeries;
    chart: ApexChart;
    colors:string[];
    dataLabels:ApexDataLabels;
    legend:any
    responsive: ApexResponsive[];
    labels: any;
  };

@Component({
    selector: 'report-list',
    templateUrl: './report-list.component.html',
    styleUrls: ['./report-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    providers: [ExcelService]
})
export class ReportListComponent implements OnInit {

    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;
    @ViewChild('sortRate') sortRate: MatSort;
    @ViewChild('paginatorU') private _paginatorU: MatPaginator;
    
    @ViewChild("FullEmptyPieChart") fullEmptyPieChart: ChartComponent;
    public fullEmptyPieChartOptions: Partial<ChartOptions>;  

    single: any[] = [];

    public tableLoading = false;
    public selectUnloadingDevice = [];
    public selectUnloadingRateDevice = [];
    public selectByFilter = "month"
    public selectByRateFilter = "month"
    public StartTime: Date;
    public EndTime: Date
    public StartRateTime: Date;
    public EndRateTime: Date

    public _containerOccupancyReport: Array<ContainerOccupancyReport>
    public _containerOccupancyReportBase: Array<ContainerOccupancyReport>
    public _containerOccupancyEmptyFullRate: Array<ContainerOccupancyEmptyFullRate>
    public _containerOccupancyEmptyFullRateBase: Array<ContainerOccupancyEmptyFullRate>
    public chartFullEmptyLabel: string[] = [];
    public chartFullEmptyData: number[] = [];

    private _containerAllList: Array<Container> = [];

    public get containerAllList(): Array<Container> {
        return this._containerAllList;
    }

    
    private _dataSource: MatTableDataSource<ContainerOccupancyReport> = undefined;
    public get dataSource(): MatTableDataSource<ContainerOccupancyReport> {
        return this._dataSource;
    }
    private _displayedColumns = ['containerName','deviceId', 'beforeDate','afterDate', 'beforeOccupancy', 'afterOccupancy','address'];

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }
    private _dataSourceRate: MatTableDataSource<ContainerOccupancyEmptyFullRate> = undefined;
    public get dataSourceRate(): MatTableDataSource<ContainerOccupancyEmptyFullRate> {
        return this._dataSourceRate;
    }
    private _displayedColumnsRate = ['deviceId', 'emptyOccupancyCount', 'fullOccupancyCount', 'emptyRate', 'fullRate', 'count', 'address'];

    public get displayedColumnsRate(): Array<string> {
        return this._displayedColumnsRate;
    }

    constructor(
        private _reportingService: ReportingService,
        private _containerService:ContainerService,
        private _excelService: ExcelService,
        private _spinner:NgxSpinnerService,
    ) {
        this.fullEmptyPieChartOptions = {
            colors: ['#A10A28', '#5AA454'],
            series: [50, 50],
            chart: {
              width: 380,
              type: "pie"
            },
          };
    }


    public async ngOnInit() {
        await this.onContainerUnloadingEmptyFullRateClick("month");
        this.updateTableDataSource()
        this.updateTableDataSourceRate()
        this.onContainerUnloadingStatusClick("month");
        this.getAllContainerList()
    }

    public async onReportClick() {
        const columns = ["No","Konteyner Adı", "Cihaz id", "Tarih","Boşaltılmadan Önce Tarih","Boşaltılmadan Sonra Tarih" ,"Boşaltılmadan Önce", "Boşaltıldıktan Sonra", "Adres"];
        let idx = 1;
        const dataset = this._containerOccupancyReport.map(p => {
            return {
                index: idx++,
                name: `${p.containerName}`,
                cihazId: `${p.deviceId}`,
                beforetarih: `${p.beforeDate}`,
                aftertarih: `${p.afterDate}`,
                dolulukOnce: `${p.beforeOccupancy}`,
                dolulukSonra: `${p.afterOccupancy}`,
                Address: `${p.address}`,

            }
        });
        this._excelService.exportAsExcelFile(
            columns,
            dataset,
            'Çöp Boşaltım Raporu',
            "",
            new Date(),
            {
                worksheetName: 'Çöp Boşaltım Raporu'
            }
        );
    }

    public async onReportRateClick() {
        const columns = ["No", "Cihaz id", "50% Altında Toplanan", "50% Üstünde Toplanan", "50% Altında ki Oran ", "50% Üstünde ki Oran", 'Toplam Toplanan', "Adres"];
        let idx = 1;
        const dataset = this._containerOccupancyEmptyFullRate.map(p => {
            return {
                index: idx++,
                cihazId: `${p.deviceId}`,
                emptyCount: `${p.emptyOccupancyCount}`,
                fullCount: `${p.fullOccupancyCount}`,
                emptyRate: `${p.emptyRate}`,
                fullRate: `${p.fullRate}`,
                count: `${p.count}`,
                Address: `${p.address}`,

            }
        });
        this._excelService.exportAsExcelFile(
            columns,
            dataset,
            'Çöp Boşaltım Oran Raporu',
            "",
            new Date(),
            {
                worksheetName: 'Çöp Boşaltım Oran Raporu'
            }
        );
    }

    
    public onUnloadingDeviceSelect() {
        if (this.selectUnloadingDevice.length == 0) {
            this._containerOccupancyReport = this._containerOccupancyReportBase;
            this.updateTableDataSource();
        } else {
            this._containerOccupancyReport = this._containerOccupancyReportBase.filter(x => this.selectUnloadingDevice.indexOf(x.deviceId) != -1)
            this.updateTableDataSource();
        }
    }

    public async onUnloadingRateSelect() {
        if (this.selectUnloadingRateDevice.length == 0) {
            this._containerOccupancyEmptyFullRate = this._containerOccupancyEmptyFullRateBase;
            await this.calculateContainerUnloadingEmptyFullRate();
            await this.updateTableDataSourceRate();
        } else {
            this._containerOccupancyEmptyFullRate = this._containerOccupancyEmptyFullRateBase.filter(x => this.selectUnloadingRateDevice.indexOf(x.deviceId) != -1)
            await this.calculateContainerUnloadingEmptyFullRate();
            await this.updateTableDataSourceRate();
        }
    }

    public onContainerUnloadingStatusClick(key: string, startTime?: Date, endTime?: Date) {
        switch (key) {
            case "day":
                var start = new Date();
                var end = new Date();
                start.setDate(start.getDate() - 1);
                this.getContainerUnloadingStatus(start, end)
                break;
            case "week":
                var start = new Date();
                var end = new Date();
                start.setDate(start.getDate() - 7);
                this.getContainerUnloadingStatus(start, end)

                break;
            case "month":
                var start = new Date();
                var end = new Date();
                start.setDate(start.getDate() - 30);
                this.getContainerUnloadingStatus(start, end)
                break;

            default:
                this.getContainerUnloadingStatus(startTime, endTime)
                break;
        }

    }

    public onContainerUnloadingEmptyFullRateClick(key: string, startTime?: Date, endTime?: Date) {
        switch (key) {
            case "day":
                var start = new Date();
                var end = new Date();
                start.setDate(start.getDate() - 1);
                this.getContainerUnloadingEmptyFullRate(start, end)
                break;
            case "week":
                var start = new Date();
                var end = new Date();
                start.setDate(start.getDate() - 7);
                this.getContainerUnloadingEmptyFullRate(start, end)

                break;
            case "month":
                var start = new Date();
                var end = new Date();
                start.setDate(start.getDate() - 30);
                this.getContainerUnloadingEmptyFullRate(start, end)
                break;

            default:
                this.getContainerUnloadingEmptyFullRate(startTime, endTime)
                break;
        }

    }

    public getContainerUnloadingEmptyFullRate(startTime?: Date, endTime?: Date) {
        try {
            this._reportingService.getContainerUnloadingEmptyFullRate(parseInt(localStorage.getItem("CompanyID")), startTime, endTime).then(response => {
                this._containerOccupancyEmptyFullRate = response;
                this._containerOccupancyEmptyFullRateBase = response;
                this.onUnloadingRateSelect()
            })
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);

        }
    }
    public getContainerUnloadingStatus(startTime?: Date, endTime?: Date) {
        try {
            this.tableLoading = true;
            this._reportingService.getContainerUnloadingStatus(parseInt(localStorage.getItem("CompanyID")), startTime, endTime).then(response => {
                this._containerOccupancyReport = response;
                this._containerOccupancyReportBase = response;
                this.onUnloadingDeviceSelect();
                this.tableLoading = false;
            })
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
        }
    }
    
    private async updateTableDataSourceRate(): Promise<void> {
        this._dataSourceRate = new MatTableDataSource<ContainerOccupancyEmptyFullRate>(this._containerOccupancyEmptyFullRate);
        this._dataSourceRate.paginator = this._paginatorU;
        this._dataSourceRate.sort = this.sortRate;
    }

    private async updateTableDataSource(): Promise<void> {
        this._dataSource = new MatTableDataSource<ContainerOccupancyReport>(this._containerOccupancyReport);
        this._dataSource.paginator = this._paginator;
        this._dataSource.sort = this._sort;
    }

    public calculateContainerUnloadingEmptyFullRate() {
        var empty = 0;
        var full = 0;
        var count = 0;
        this._containerOccupancyEmptyFullRate.forEach(x => {
            empty += x.emptyOccupancyCount;
            full += x.fullOccupancyCount;
            count += x.count;
        })
        var data1 = ((empty * 100) / count).toFixed(2);
        var data2 = ((full * 100) / count).toFixed(2);
        
        this.fullEmptyPieChartOptions = {
            colors: ['#A10A28', '#5AA454'],
            series: [parseFloat(data1), parseFloat(data2)],
            chart: {
              width: 380,
              type: "pie"
            },
            labels: ["Verimsiz Toplama", "İdeal Toplama"],
            legend: {
                fontWeight: 600,
                labels: {
                  useSeriesColors: true,
                },
              },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 200
                  },
                  legend: {
                    position: "bottom"
                  }
                }
              }
            ]
          };

        this.single = [{ name: "Verimsiz Toplama", value: data1 }, { name: "İdeal Toplama", value: data2 }]
        this.chartFullEmptyData = [parseFloat(data1), parseFloat(data2)]
    }
    private async getAllContainerList(): Promise<void> {
        try {
            this._containerAllList = await (await this._containerService.getAllContainerDetail(parseInt(localStorage.getItem("CompanyID")))).filter(x => x.containerType != true);
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
        }
    }
}
